import React, { useState, useEffect, useRef } from "react";
import { UserIdha } from "@idha/idha-types";
import { UserExchange } from "../presentation/UserExchange";
import { store } from "../../../../../redux/store/store";
import { connectWithStore } from '../../../../../connectWithStore';
import { hideUserExchangeDialog } from '../../../../../redux/actions/users.actions';
import { ThemeProvider } from "@material-ui/core";
import theme from "../../../../../js/material-ui-theme";

export class UserExchangeContainerProps {
    users?: UserIdha[]    
    doLogin?:(email:string,password:string)=>void
    doLogout?:()=>void
    onCancel?:()=>void

    //Recebidos via REDUX
    close?: () => void
    isOpen?: boolean
    userPhotoContainerUrl?: string
}


const mapStateToProps = function (state) {
    return {
        users: state.users?.userList,
        isOpen: state.users?.exchangeUserVisible
    }
}

const mapDispatchToProps = function (dispatch) {
    return {
        close: () => (dispatch(hideUserExchangeDialog()))
    }
}


const ConnectedUserExchangeContainer = function (props: UserExchangeContainerProps) {
    const getUserPhotoUrl = function (user: UserIdha): string {
        let url = `${props.userPhotoContainerUrl}/download/${user.currentPhoto?.filename}`
        return url;
    }

    let [apiError, setApiError] = useState(undefined);

    async function doLogout() {
        props.doLogout?.();
    }
    async function doLogin(user:UserIdha,password: string, event: any) {
        props.close();
        await props.doLogin(user.email,password);        
    }
    function handleCancel(){
        props.close();
        props.onCancel();
    }

    useEffect(() => {
        if (props.isOpen) {
            doLogout();
        }
    }, [props.isOpen])

    const users = (props?.users?.map(a => ({ ...a })) || []);

    return (<ThemeProvider theme={theme}>
                <UserExchange open={props.isOpen} onCancel={handleCancel} users={users} getUserPhotoUrl={getUserPhotoUrl} onConclude={doLogin}/>
            </ThemeProvider>);
}


export const UserExchangeContainer = connectWithStore(
    store,
    ConnectedUserExchangeContainer,
    mapStateToProps,
    mapDispatchToProps
)